const mpPhrase = "#mpform";
const httpsMpPhrase = `https://${mpPhrase}`;
const httpMpPhrase = `http://${mpPhrase}`;

export const getMpFormLink = (formId: string) => `/formulieren/${formId}`;

export const isMailPlusLink = (link: string | null | undefined): boolean => {
    if (link) {
        return link.startsWith(mpPhrase) || link.startsWith(httpsMpPhrase) || link.startsWith(httpMpPhrase);
    }
    return false;
}

export const maybeToMailPlusLink = (link: string | undefined): string | undefined => {
    if(isMailPlusLink(link)) {
        return toMpFormLink(link)
    }

    return link
}

export const getMailPlusFormId = (link: string | null | undefined): string | null => {
    if (!link) return null;
    if (link.startsWith(mpPhrase)) return link.substring(mpPhrase.length);
    if (link.startsWith(httpsMpPhrase)) return link.substring(httpsMpPhrase.length);
    if (link.startsWith(httpMpPhrase)) return link.substring(httpMpPhrase.length);
    return null;
}

export const toMpFormLink = (link: string | null | undefined): string => getMpFormLink(getMailPlusFormId(link) ?? '');